//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseSpinner from './BaseSpinner.vue';
import CommentsListComment from './CommentsListComment.vue';
import CommentsListForm from './CommentsListForm.vue';

export default {
    components: {
        BaseSpinner,
        CommentsListComment,
        CommentsListForm,
    },

    props: {
        comments: {
            type: Object,
            default: () => ({}),
        },
        singleId: {
            type: Number,
            default: null,
        },
        singleCommentStatus: {
            type: String, // 'open' || 'closed'
            default: null,
        },
        hideComments: {
            type: Boolean,
            default: false,
        },
    },

    created() {
        this.getHeader();
    },

    methods: {
        emitVisibleLastComment(isVisible, index) {
            if (!isVisible || this.comments.nodes.length !== index) return;

            this.$emit('is-visible-last');
        },
        getHeader() {
            const output = { title: 'Comentarii' };

            if (this.singleCommentStatus === 'closed') output.title = 'Comentariile au fost închise';
            else if (this.hideComments) {
                Object.assign(output, {
                    title: 'Comentariile sunt ascunse momentan',
                    subtitle: 'Dar tu poți adăuga oricând comentariul tău pentru concurs.',
                });
            }

            this.header = output;
        },
    },
};
